import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../providers/appProvider';

import cl from "./Add.module.css"
import Plus from "../../../../assets/Icon/Plus"; 
import Modal from '../../../UI/Modal/Modal'
import Pen from "../../../../assets/Icon/Pen";
import Select from "react-select";
import { selectStyle } from './selectStyle';
import AddClientForm from '../ClientForm/ClientForm';
import { validatePhoneNumber } from '../../../../utils/phone';
import { useBooking } from "../../../../hooks/useBooking";
import { useUser } from '../../../../hooks/useUser';

const Add = ({ QuotationService, defaultQuotation }) => {

    const initQuotationModel = (Quotation) => {
        return {
            id: 0,
            quotation_id:"0",
            seller_id: 0,
            status_id: 0,
            user_id: 0,

            sender_country_id: 0,
            sender_city_id: 0,
            reciever_country_id: 0,
            reciever_city_id: 0,
            type_id: 0, // Select transportation id
            created_at: '',
            updated_at: '',

            marine_subtype_id: 0,
            icoterm_id: 0,
            land_subtype_id: 0,
            railway_subtype_id: 0,
            marine_line_id:0,
            period_start_at: '',
            period_end_at: '',
            
            issued_price: 0,
        }
    }

    const initialTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'საზღვაო' },
        { value: 2, label: 'სახმელეთო' },
        { value: 3, label: 'სარკინიგზო' },
        { value: 4, label: 'საჰაერო' },
      ];
      
      
      const marineSubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FCL' },
        { value: 2, label: 'LCL' },
        { value: 3, label: 'Oversized' },
      ];
      
      const landSubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FTL' },
        { value: 2, label: 'LTL' },
        { value: 3, label: 'FCL' },
        { value: 4, label: 'Oversized' },
      ];
      
      const railwaySubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FCL' },
        { value: 2, label: 'LCL' },
        { value: 3, label: 'Wagon' },
        { value: 4, label: 'Cistern' },
        { value: 5, label: 'Oversized' },
      ];
      
      const incotermTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FOB' },
        { value: 2, label: 'FCA' },
        { value: 3, label: 'ExW' },
        { value: 4, label: 'DAP' },
        { value: 5, label: 'CIF' },
      ];
      
      const statusTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'წაგებული' },
        { value: 2, label: 'მიმდინარე' },
        { value: 3, label: 'მოგებული' },
      ];
      


    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);
    const [newQuotation, setNewQuotation] = useState(initQuotationModel(null))
    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const [validates, setValidates] = useState({})
    const [tmpStatus, setTmpStatus] = useState(0);
    const { userService } = useUser(-1)
    const { BookingService } = useBooking(50, true);
    
    const handleTypeIdChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            type_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleMarineSubtypeChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            marine_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleIncotermChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            icoterm_id: selectedOption ? selectedOption.value : 0
        }));
    };
    const handleLandSubtypeChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            land_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleRailwaySubtypeChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            railway_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleStatusTypeChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            status_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const openAdd = () => {
        setNewQuotation(initQuotationModel(null))
        setIsModalOpen(true)
    }
    // console.log(appState.user)
    const saveHandle = async () => {
        setValidates({});
        const isValidate = validateQuotation(newQuotation)

        if (isValidate === true) {
            console.log(newQuotation)
            console.log(appState.user)
            if(newQuotation.seller_id == 0) {
                newQuotation.seller_id = appState.user.id
            }

            console.log("new quotation: ", newQuotation)
            if(newQuotation.client && newQuotation.client.id == 0) {
                newQuotation.client = {
                    id: 0,
                    firstname: newQuotation.client.firstname,
                    lastname: newQuotation.client.lastname,
                    personal: newQuotation.client.personal,
                    email: newQuotation.client.email,
                    mobile: newQuotation.client.mobile,
                    password: "123456",
                    role_id: 36,
                }
                const newUserId = await userService.add(newQuotation.client);
                console.log(newUserId.id)
                newQuotation.user_id = newUserId.id
            }


            newQuotation.created_at = new Date().toLocaleString()
            const tmp = await QuotationService.add(newQuotation)

            if(newQuotation.status_id === 3) {
                const bookingData = {
                    id: 0,
                    Booking_id:"0",
                    seller_id: newQuotation.seller_id,
                    status_id: 4,
                    user_id: newQuotation.user_id,
            
                    sender_country_id: newQuotation.sender_country_id,
                    reciever_country_id: newQuotation.reciever_country_id,
                    type_id: newQuotation.type_id,
                    created_at: newQuotation.created_at,
                    updated_at: newQuotation.updated_at,
                    message: '',
                    description: '',
                    icoterm_id: newQuotation.icoterm_id,
                    land_subtype_id: newQuotation.land_subtype_id,
                    railway_subtype_id: newQuotation.railway_subtype_id,
                    marine_line_id: newQuotation.marine_line_id,
                    period_start_at: '',
                    period_end_at: '',
                    quotation_id: tmp.id,

                    issued_price: newQuotation.issued_price
                }

                console.log(bookingData)
        
                await BookingService.add(bookingData);
            }
            console.log(newQuotation)
            setIsModalOpen(false)
        } else {
            console.log("Not valid or error")
            // setIsFirstValidated(true)
        }
    };

    const validateQuotation = (Quotation) => {
        const messages = {};

        if (Quotation.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (Quotation.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (Quotation.status_id === 0) {
            messages.status_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (Quotation.type_id === 0) {
            messages.type_id = { message: 'სავალდებულოა', isValid: false };
        }

        console.log(Quotation)

        if (Quotation.type_id === 1) { // Marine
            if (!Quotation.marine_subtype_id || Quotation.marine_subtype_id < 1) {
                messages.marine_subtype_id = { message: 'სავალდებულოა', isValid: false };
            }
        } else if (Quotation.type_id === 2) { // Land
            if (!Quotation.land_subtype_id || Quotation.land_subtype_id < 1) {
                messages.land_subtype_id = { message: 'სავალდებულოა', isValid: false };
            }
        } else if (Quotation.type_id === 3) { // Railway
            if (!Quotation.railway_subtype_id || Quotation.railway_subtype_id < 1) {
                messages.railway_subtype_id = { message: 'სავალდებულოა', isValid: false };
            }
        }

        if (Quotation.icoterm_id === 0) {
            messages.icoterm_id = { message: 'სავალდებულოა', isValid: false };
        }


        if (Quotation.client_id === 0) {

            if (!Quotation.client.firstname || Quotation.client.firstname.length < 2) {
                messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
            }


            if (!Quotation.client.lastname || Quotation.client.lastname.length < 2) {
                messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
            }


            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

            if (!Quotation.client.email || Quotation.client.email.length < 2 || !emailRegex.test(Quotation.client.email)) {
                messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
            }
    
            if (!Quotation.client.mobile || !validatePhoneNumber(Quotation.client.mobile)) {                
                messages.mobile = { message: 'ნომერი არასწორია', isValid: false };
            }  
        } 

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    return(
        <div>
            <span className={cl.AddBtn} onClick={() => openAdd()} >
                <span className={cl.icon} > <Plus /></span>
                დამატება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead} >
                    <h3><span className={cl.iconHead} > <Pen /></span> დამატება</h3>
                </div>

                <AddClientForm newQuotation={newQuotation} setNewQuotation={setNewQuotation} validates={validates}></AddClientForm>

                <fieldset className={cl.formField} style={{marginTop: '15px'}}>
                    <legend>ჩატვირთვის ქვეყანა</legend>
                    <Select
                        options={appState.countries}
                        value={appState.countries.find(country => country.id === newQuotation.sender_country_id) || null}
                        onChange={(selectedOption) => {
                            setNewQuotation(prevState => ({
                            ...prevState,
                            sender_country_id: selectedOption ? selectedOption.id : 0,
                            }));
                        }}
                        placeholder="ქვეყანა"
                        styles={selectStyle}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}  
                    />

                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიმღების ქვეყანა</legend>
                    <Select
                        options={appState.countries}
                        value={appState.countries.find(country => country.id === newQuotation.reciever_country_id) || null}
                        onChange={(selectedOption) => {
                            setNewQuotation(prevState => ({
                            ...prevState,
                            reciever_country_id: selectedOption ? selectedOption.id : 0,
                            }));
                        }}
                        placeholder="ქვეყანა"
                        styles={selectStyle}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}  
                    />
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px', flexDirection: 'column' }} className={cl.formField}>                        
                        <div style={{ display: "flex", gap: '10px' }}>
                            <div style={{ width: "50%" }}>
                            <legend>გაცემული ფასი</legend>
                                <input
                                    type="number"
                                    className={`${cl.input} ${validates?.issued_price ? cl.error : 0}`}
                                    value={newQuotation.issued_price}
                                    onChange={(e) => {
                                        setNewQuotation(prevState => ({
                                            ...prevState,
                                            issued_price: parseInt(e.target.value)
                                        }));
                                    }}
                                    min={0}
                                    defaultValue={0}
                                    placeholder="გაცემული ფასი"
                                />
                            </div>
                        </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>სტატუსი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={statusTypes}
                            value={statusTypes.find(option => option.value === newQuotation.status_id)}
                            onChange={handleStatusTypeChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>გადაზიდვის ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newQuotation.type_id)}
                            onChange={handleTypeIdChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                {newQuotation.type_id === 1 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={marineSubtype}
                                value={marineSubtype.find(option => option.value === newQuotation.marine_subtype_id)}
                                onChange={handleMarineSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newQuotation.type_id == 2 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={landSubtype}
                                value={landSubtype.find(option => option.value === newQuotation.land_subtype_id)}
                                onChange={handleLandSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newQuotation.type_id == 3 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={railwaySubtype}
                                value={railwaySubtype.find(option => option.value === newQuotation.railway_subtype_id)}
                                onChange={handleRailwaySubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                )
                : (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                        <div style={{ width: "50%" }}></div>
                    </fieldset>
                )}

                <span onClick={saveHandle} className={cl.btnPrimary}>დამატება</span>


            </Modal>
        </div>
    )
}

export default Add;